import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  NEWSFEED_QUICKLINKS_FEATURE_KEY,
  newsfeedQuicklinksAdapter,
  NewsfeedQuicklinksState,
} from './newsfeed-quicklinks.reducer';

// Lookup the 'NewsfeedQuicklinks' feature state managed by NgRx
export const selectNewsfeedQuicklinksState = createFeatureSelector<NewsfeedQuicklinksState>(
  NEWSFEED_QUICKLINKS_FEATURE_KEY
);

const { selectAll } = newsfeedQuicklinksAdapter.getSelectors();

export const selectNewsfeedQuicklinksLoaded = createSelector(
  selectNewsfeedQuicklinksState,
  (state: NewsfeedQuicklinksState) => state.loaded
);

export const selectNewsfeedQuicklinksError = createSelector(
  selectNewsfeedQuicklinksState,
  (state: NewsfeedQuicklinksState) => state.error
);

export const selectAllNewsfeedQuicklinks = createSelector(
  selectNewsfeedQuicklinksState,
  (state: NewsfeedQuicklinksState) => selectAll(state)
);
